import { trpc } from "../helpers/trpc";

interface UseCommunicationChannelUsageProps {
  formId?: string;
  enabled?: boolean;
}

export const useCommunicationChannelUsage = ({ formId, enabled = true }: UseCommunicationChannelUsageProps = {}): {
  hasSmsChannel: boolean;
  isLoading: boolean;
} => {
  const { data, isLoading } = trpc.getCommunicationChannelUsage.useQuery(
    { formId },
    {
      staleTime: 5 * 60 * 1000,
      enabled,
    }
  );

  return { hasSmsChannel: Boolean(data?.hasSmsChannel), isLoading };
};
